import { useDisplayUserName } from 'hooks/useDisplayUserName'
import Styles from './ActivityEvent.module.scss'

interface Props {
  count?: number
  userId?: number | null
  displayName: string
  capitalizeFirstLetter?: boolean
}

const Actor = ({ count = 1, displayName, userId, capitalizeFirstLetter = false }: Props) => {
  const name = useDisplayUserName(displayName, userId, capitalizeFirstLetter)

  const text = count !== 1 ? `${count} people` : name
  return <span className={Styles.actor}>{text}</span>
}

export { Actor }
